<template>
  <div>
    <div class="container-fluid full-height">
      <div class="row row-height">
        <hello />

        <div class="col-lg-6" id="start">
          <div id="wizard_container">
            <div id="top-wizard">
              <div id="progressbar"></div>
            </div>
            <div class="mb-2">
              <LanguageSelect />
            </div>
            <!-- /top-wizard -->
            <form id="wrapped" method="POST" @submit.prevent="renew">
              <input id="website" name="website" type="text" value />
              <!-- Leave for security protection, read docs for details -->
              <div id="middle-wizard">
                <div class="submit step">
                  <div class="form-group"></div>
                  <h3 class="main_question">{{ $t('Şifreni Sıfırla') }}</h3>
                  <p>
                    {{ $t('Şifreni Sıfırla Aciklama') }}
                  </p>
                  <div class="row">
                    <div class="col-6">
                      <div class="form-group">
                        <div class="password-input">
                          <input
                            v-model="password"
                            class="form-control"
                            name="password1"
                            :placeholder="$t('Şifre')"
                            :class="{ 'is-invalid': errors.first('password1') }"
                            :type="showPassword ? 'text' : 'password'"
                            v-validate="'required'"
                            ref="password1"
                          />
                          <svg
                            v-if="!showPassword"
                            @click="showPassword = !showPassword"
                            class="password-eye"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="#9d9d9d"
                              d="M4.707 3.293a1 1 0 0 0-1.414 1.414l2.424 2.424c-1.43 1.076-2.678 2.554-3.611 4.422a1 1 0 0 0 0 .894C4.264 16.764 8.096 19 12 19c1.555 0 3.1-.355 4.53-1.055l2.763 2.762a1 1 0 0 0 1.414-1.414zm10.307 13.135c-.98.383-2 .572-3.014.572c-2.969 0-6.002-1.62-7.87-5c.817-1.479 1.858-2.62 3.018-3.437l2.144 2.144a3 3 0 0 0 4.001 4.001zm3.538-2.532c.483-.556.926-1.187 1.318-1.896c-1.868-3.38-4.9-5-7.87-5q-.168 0-.336.007L9.879 5.223A10.2 10.2 0 0 1 12 5c3.903 0 7.736 2.236 9.894 6.553a1 1 0 0 1 0 .894a13 13 0 0 1-1.925 2.865z"
                            />
                          </svg>
                          <svg
                            v-if="showPassword"
                            @click="showPassword = !showPassword"
                            class="password-eye"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                          >
                            <g fill="#9d9d9d">
                              <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0" />
                              <path
                                d="M21.894 11.553C19.736 7.236 15.904 5 12 5s-7.736 2.236-9.894 6.553a1 1 0 0 0 0 .894C4.264 16.764 8.096 19 12 19s7.736-2.236 9.894-6.553a1 1 0 0 0 0-.894M12 17c-2.969 0-6.002-1.62-7.87-5C5.998 8.62 9.03 7 12 7s6.002 1.62 7.87 5c-1.868 3.38-4.901 5-7.87 5"
                              />
                            </g>
                          </svg>
                        </div>

                        <span v-show="errors.first('password1')" class="invalid-feedback">{{
                          errors.first('password1')
                        }}</span>
                      </div>
                    </div>
                    <div class="col-6">
                      <InputField
                        v-model="password_confirmation"
                        name="password2"
                        :placeholder="$t('Şifre Tekrar')"
                        v-validate="'required|confirmed:password1'"
                        :error="errors.first('password2')"
                        :type="showPassword ? 'text' : 'password'"
                        :validateFields="fields['password2']"
                      />
                    </div>
                  </div>
                  <PasswordInfo
                    :password="password"
                    :password_confirmation="password_confirmation"
                    ref="passwordInfo"
                  />
                </div>
                <button type="submit" name="process" class="submit" :disabled="isWaiting">
                  {{ $t('Şifremi Güncelle') }}
                </button>
              </div>
            </form>
            <div id="bottom-wizard"></div>
            <!-- /bottom-wizard -->
            <div class="form-group">
              <div class="row">
                <div class="col-12">
                  <strong>
                    <router-link :to="pathFindWithLanguage('/login')">{{ $t('Giriş Yap') }}</router-link>
                  </strong>
                </div>
              </div>
            </div>
          </div>
          <!-- /Wizard container -->
        </div>
        <!-- /content-right-->
      </div>
      <!-- /row-->
    </div>
    <!-- /container-fluid -->
  </div>
</template>
<script>
import LanguageSelect from './../components/LanguageSelect.vue';
import PasswordInfo from './../components/PasswordInfo.vue';
import InputField from './../components/InputField.vue';
export default {
  components: {
    LanguageSelect,
    PasswordInfo,
    InputField,
  },
  data() {
    return {
      password: null,
      password_confirmation: null,
      passwordsInfoText: '',
      showPassword: false,
    };
  },
  methods: {
    renew(event) {
      if (!this.$refs.passwordInfo.isPassed) {
        this.$toasted.error(this.$t('Şifre Mesajları.Parolanızı Kontrol Edin'));
        return;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          event.preventDefault();

          const q = this.$route.query.q;
          const decode = atob(q);
          const [email, code] = decode.split('|');

          const form = $('form#wrapped');
          form.validate();
          if (form.valid()) {
            this.startWaiting();
            $axios
              .put('update-password', {
                email,
                code,
                password: this.password,
                password_confirmation: this.password_confirmation,
              })
              .then((s) => {
                this.$toasted.show(this.$t('AlertMessages.Parolanız güncellendi, şimdi giriş yapabilirsiniz'), {
                  action: [
                    {
                      text: this.$t('Giriş Yap'),
                      onClick() {
                        Vue.$router.push({ name: 'login' });
                      },
                    },
                  ],
                });
              });
          }
        }
      });
    },
  },
};
</script>

<style>
.password-input {
  position: relative;
}

.password-eye {
  position: absolute;
  right: 0.5rem;
  transform: translateY(-50%);
  top: 50%;
  cursor: pointer;
  z-index: 1;

  fill: red;
}
</style>
